import React, {useCallback} from 'react';

import GermlineSelector from 'antibodies/germline/GermlineSelector';
import {maybeGetValueFromConfig} from 'pipelines/generalized-step-config-editor/step-config-settings/StepConfigSettingsUtils';
import {CustomComponentEditorProps} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';

export default function GermlineEditor({
  config,
  onChangeConfig,
  disabled,
}: CustomComponentEditorProps): JSX.Element {
  const selectedGermlineId =
    (maybeGetValueFromConfig(config, ['germlineId']) as string | null | undefined) ?? null;

  const handleSelectGermline = useCallback(
    (germlineId: string) => {
      onChangeConfig(config, ['germlineId'], germlineId);
    },
    [config, onChangeConfig]
  );

  return (
    <GermlineSelector
      selectedGermlineId={selectedGermlineId}
      onSelectGermline={handleSelectGermline}
      disabled={Boolean(disabled)}
    />
  );
}
